import React from 'react';
import './App.css';
import { NavLink } from 'react-router-dom';


function Nav() {
 
    return (
    <nav id="navigation">
        <NavLink to="/">
        <h3 id="navTitle">Highway 60</h3>
        </NavLink>

        <ul className="navLinks">
        {/* to create links, we need to wrap every <li> item inside a <Link> tag. It takes one attribute, to="" which is the path to the page the nav text links to */}
            <NavLink to="/">
                <li>Home</li>
            </NavLink> 

            <NavLink to="/articles" >
                <li>Blog</li>
            </NavLink>

            <NavLink to="/about">
                <li>David Ben Horin</li>
            </NavLink>         
            <br/>     
            <br />
            <span style={{color: "black", fontSize: "1.25em", fontWeight: "bold"}}>Tags:</span>   
        <NavLink to="/articles-tag-story" >
                <li>Stories</li>
            </NavLink>
            <NavLink to="/articles-tag-development" >
                <li>Developer</li>
            </NavLink>
            <NavLink to="/articles-tag-published" >
                <li>Articles</li>
            </NavLink>
            <NavLink to="/articles-tag-life-charge" >
                <li>Life Charge</li>
            </NavLink>
        </ul>
                

    </nav>

);
}

export default Nav;